export enum SaveOrderEnum {
  NORMAL = 'NORMAL',
  FAST = 'FAST',
  TERMINAL = 'TERMINAL',
}
